export class Tenant {
    TenantCode: string = '';
    TenantName: string = '';
    SolutionId: string = '';
    DomainName: string = '';
    Server: string = '';
    DatabaseName: string = '';
    ClientType: number = 0;
    ClientOrganizationType: number = 0;
    IsActive: boolean = false;
    IsMigratedClient: boolean = false;
}
